var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "div",
        { staticClass: "soli-grey font-weight-bold text-start px-1 pb-4" },
        [_vm._v("\n        " + _vm._s(_vm.getTitle) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "stripe-shadow soli-round", attrs: { outlined: "" } },
        [
          _c("v-textarea", {
            ref: "textarea",
            attrs: {
              value: _vm.value,
              label: "Experience, interests, goals...",
              placeholder: _vm.getTitle,
              "auto-grow": "",
              solo: "",
              flat: "",
              "hide-details": "auto",
              rules: _vm.noteRules,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              "update:error": function ($event) {
                return _vm.validate($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }